import styles from "./dash.module.css";

interface Props {
  label: string;
  value: string | number;
  note?: string;
  tone?: "default" | "danger" | "warn" | "ok";
}

/** KPI cell: kicker label, display number, a text note (never colour alone). */
export const MetricTile = ({ label, value, note, tone = "default" }: Props) => (
  <div className={styles.tile}>
    <div className="osi-kicker">{label}</div>
    <div className={`${styles.tileValue} osi-num ${tone !== "default" ? styles["tone_" + tone] : ""}`}>{value}</div>
    {note && <div className={styles.tileNote}>{note}</div>}
  </div>
);
